(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cbf-cart-benefits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  if(!event.target.closest('#cbfa-edit'))return;
  const details=document.getElementById('cbfa-address-details');
  if(details){details.open=true;document.getElementById('cbfd-address')?.focus();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cbf-hue-gift-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('cbf-hue-gift-guard')) return;

  const isGift = item => {
    const p = item.properties || {};
    return typeof p._alpha_free_gift_mode === 'string' &&
      p._alpha_free_gift_mode.length > 0 &&
      typeof p._alpha_offer_id === 'string' && p._alpha_offer_id.length > 0 &&
      typeof p['_Offer Identity'] === 'string' && p['_Offer Identity'].length > 0;
  };

  const inspect = (cart, catalog = []) => {
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) {
      throw new Error('Invalid cart');
    }
    const gifts = cart.items.filter(isGift);
    const giftTotal = gifts.reduce((total, item) => {
      if (!Number.isFinite(item.final_line_price)) throw new Error('Invalid gift price');
      return total + item.final_line_price;
    }, 0);
    const paidTotal = cart.total_price - giftTotal;
    const ranges = [600, 800, 900, 1000];
    const byProduct = new Map(catalog.map(p => [p.id, p]));
    const byVariant = new Map(catalog.map(p => [p.variant, p]));
    const totals = new Map();
    const budgetProducts = new Set([8133897715977, 8137296118025, 9361778376969]);
    let budgetTotal = 0;
    for (const item of cart.items.filter(item => !isGift(item))) {
      if (budgetProducts.has(item.product_id)) {
        budgetTotal += Math.max(0, item.final_line_price);
        continue;
      }
      const p = byProduct.get(item.product_id);
      if (p && ranges.includes(p.tier) && item.final_line_price > 0) {
        totals.set(p.tier, (totals.get(p.tier) || 0) + item.final_line_price);
      }
    }
    const dominant = [...totals].sort((a, b) => b[1] - a[1] || b[0] - a[0])[0];
    const tier = budgetTotal > (dominant?.[1] || 0) ? 600 : dominant?.[0] || 0;
    const allowance = cart.currency !== 'EUR' || !tier ? 0 : paidTotal >= 9000 ? 2 : paidTotal >= 5000 ? 1 : 0;
    let remaining = allowance;
    const updates = {};
    for (const item of gifts) {
      if (!Number.isInteger(item.quantity) || item.quantity < 1 || typeof item.key !== 'string' || !item.key) {
        throw new Error('Invalid gift line');
      }
      const p = byVariant.get(item.variant_id);
      const allowed = p && ranges.includes(p.tier) && p.tier <= tier;
      const quantity = allowed && item.final_line_price === 0 ? Math.min(item.quantity, remaining) : 0;
      remaining -= quantity;
      if (quantity !== item.quantity) updates[item.key] = quantity;
    }
    const variants = catalog.filter(p => ranges.includes(p.tier) && p.tier <= tier && p.available).map(p => String(p.variant));
    return { gifts, tier, eligible: allowance > 0, variants, updates };
  };

  class GiftGuard extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.version = 0;
      this.root = window.Shopify?.routes?.root || '/';
      this.reloading = false;
      this.replaying = false;
      this.pending = false;
      this.checkoutBusy = false;
      this.running = null;
      this.notBefore = 0;
      this.catalog = [...document.querySelectorAll('[data-gift-catalog], [data-cbf-extra-gift-catalog]')]
        .flatMap(node => JSON.parse(node.textContent));
      this.allowedVariants = new Set();
      document.documentElement.dataset.cbfHueGuard = 'true';
      document.documentElement.dataset.cbfHueEligible = 'false';
      this.observer = new MutationObserver(() => this.filterCards());
      this.observer.observe(document.querySelector('main'), { childList: true, subtree: true });

      this.updated = () => this.schedule();
      this.onChange = event => {
        if (event.target.matches('input[name="updates[]"]')) {
          this.notBefore = Date.now() + 700;
          this.schedule();
        }
      };
      this.onClick = event => {
        const target = event.target.closest?.('button, input, a');
        if (!target) return;
        const card = target.closest('.alpha-free-gift-card');
        if (card && !this.allowedVariants.has(card.querySelector('select')?.value)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.schedule();
          return;
        }
        if (target.closest('quantity-input, cart-remove-button')) {
          this.notBefore = Date.now() + 700;
          this.schedule();
        }
        const href = target.getAttribute('href') || '';
        if (target.name === 'checkout' || /\/checkout\/?(?:\?|$)/.test(href)) {
          this.beforeCheckout(event, () => target.click());
        }
      };
      this.onSubmit = event => {
        const submitter = event.submitter;
        const form = event.target;
        if (submitter?.name === 'checkout') {
          this.beforeCheckout(event, () => form.requestSubmit(submitter));
        }
      };
      document.addEventListener('click', this.onClick, true);
      document.addEventListener('submit', this.onSubmit, true);
      document.addEventListener('change', this.onChange, true);
      document.addEventListener('cart:updated', this.updated);
      document.addEventListener('cart:change', this.updated);
      document.addEventListener('cbf:cart-state', this.updated);
      window.addEventListener('pageshow', this.updated);
      window.addEventListener('focus', this.updated);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.updated);
      }
      this.schedule();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.unsubscribe?.();
      this.observer?.disconnect();
      document.removeEventListener('click', this.onClick, true);
      document.removeEventListener('submit', this.onSubmit, true);
      document.removeEventListener('change', this.onChange, true);
      document.removeEventListener('cart:updated', this.updated);
      document.removeEventListener('cart:change', this.updated);
      document.removeEventListener('cbf:cart-state', this.updated);
      window.removeEventListener('pageshow', this.updated);
      window.removeEventListener('focus', this.updated);
    }

    schedule() {
      if (this.reloading) return;
      this.version++;
      this.pending = true;
      document.documentElement.dataset.cbfHueEligible = 'false';
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.reconcile().catch(() => this.showError()), 150);
    }

    filterCards() {
      document.querySelectorAll('.alpha-free-gift-card').forEach(card => {
        card.dataset.cbfGiftAllowed = String(this.allowedVariants.has(card.querySelector('select')?.value));
      });
    }

    async request(path, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(this.root + path, {
          credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();
        if (cart.errors || cart.status >= 400) throw new Error('Cart update failed');
        return cart;
      } finally {
        clearTimeout(timer);
      }
    }

    reconcile() {
      if (this.running) return this.running;
      this.running = this.check().finally(() => { this.running = null; });
      return this.running;
    }

    async check() {
      do {
        this.pending = false;
        const deadline = Date.now() + 15000;
        while (Date.now() < this.notBefore || document.querySelector('.cart__items--disabled')) {
          if (Date.now() >= deadline) throw new Error('Cart update still pending');
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        const version = this.version;
        const cart = await this.request('cart.js');
        if (version !== this.version) { this.pending = true; continue; }
        const state = inspect(cart, this.catalog);
        this.allowedVariants = new Set(state.variants);
        this.filterCards();
        document.documentElement.dataset.cbfHueEligible = String(state.eligible);
        if (Object.keys(state.updates).length) {
          const updates = state.updates;
          await this.request('cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          const verified = await this.request('cart.js');
          const remaining = inspect(verified, this.catalog);
          if (Object.keys(remaining.updates).length) throw new Error('Gift still present');
          this.reloading = true;
          window.location.reload();
          return false;
        }
      } while (this.pending && !this.reloading);
      return !this.reloading;
    }

    async beforeCheckout(event, proceed) {
      if (this.replaying) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.checkoutBusy || this.reloading) return;
      this.checkoutBusy = true;
      try {
        if (this.running) await this.running;
        if (this.reloading) return;
        if (await this.reconcile()) {
          this.replaying = true;
          try { proceed(); } finally { this.replaying = false; }
        }
      } catch (_) {
        this.showError();
      } finally {
        this.checkoutBusy = false;
      }
    }

    showError() {
      document.documentElement.dataset.cbfHueEligible = 'false';
      const errors = document.getElementById('cart-errors');
      if (errors) {
        errors.setAttribute('role', 'alert');
        errors.textContent = window.cartStrings?.error || '';
      }
    }
  }

  customElements.define('cbf-hue-gift-guard', GiftGuard);
})();
  } catch(e) { console.error(e); }
})();

})();
